export default `
  query {
    buscarArquivos {
      urlContratoVeloeCliente
      urlManualUsuario
      urlPoliticaDePrivacidade
      versionContratoVeloeCliente
    }
  }
`;
